import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useField } from 'formik';
import { DateTime } from 'luxon';

import FormikRawInput from './FormikRawInput';
import useInput from '../hooks/useInput';

export interface FormikDateProps {
  id?: string;
  label?: string;
  name: string;
  placeholder?: string;
  classInput?: string;
  inputProps?: object;
  icon?: string;
  swap?: boolean;
  isTo?: boolean;
  iconProps?: object;
  className?: string;
  valueLocale?: string;
  max?: number;
  required?: boolean;
}

export function FormikDate({
  id: defaultId,
  label,
  name,
  placeholder,
  classInput,
  inputProps = {},
  icon,
  swap = false,
  iconProps = {},
  className,
  valueLocale = 'us',
  max,
  required,
  isTo = false
}: FormikDateProps) {
  const [, meta, helpers] = useField(name);
  const { id, idIcon, idFeedback, ariaDescribedby } = useInput(defaultId, label, icon);
  const selected = meta.value ? meta.value.toFormat('yyyy-MM-dd') : meta.value;

  return (
    <div className={classNames(className)}>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <FormikRawInput
        id={id}
        max={max}
        required={required}
        placeholder={placeholder}
        ariaDescribedby={ariaDescribedby}
        type="date"
        classInput={classInput}
        inputProps={inputProps}
        icon={icon}
        idIcon={idIcon}
        swap={swap}
        iconProps={iconProps}
        idFeedback={idFeedback}
        meta={meta}
        value={selected}
        onChange={(event) => {
          if (isTo) {
            const date = DateTime.fromISO(event.target.value).setLocale(valueLocale).plus({ hour: 23, minute: 59, second: 59 });
            helpers.setValue(date);
          } else {
            helpers.setValue(DateTime.fromISO(event.target.value).setLocale(valueLocale));
          }
        }}
      />
    </div>
  );
}

FormikDate.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  classInput: PropTypes.string,
  inputProps: PropTypes.object,
  icon: PropTypes.string,
  swap: PropTypes.bool,
  isTo: PropTypes.bool,
  iconProps: PropTypes.object,
  className: PropTypes.string,
  valueLocale: PropTypes.string,
  max: PropTypes.string
};

export default FormikDate;
